import { toRgba } from '../to-rgba/to-rgba.mjs';

function darken(color, alpha) {
  if (color.startsWith("var(")) {
    return "color-mix(in srgb, ".concat(color, ", black ").concat(alpha * 100, "%)");
  }

  var _toRgba = toRgba(color),
      r = _toRgba.r,
      g = _toRgba.g,
      b = _toRgba.b,
      a = _toRgba.a;

  var f = 1 - alpha;

  var dark = function dark(input) {
    return Math.round(input * f);
  };

  return "rgba(".concat(dark(r), ", ").concat(dark(g), ", ").concat(dark(b), ", ").concat(a, ")");
}

export { darken };